module.exports = __webpack_public_path__ + "img/竞赛-2.24bf394b.png";